import { IonImg, IonRow } from '@ionic/react';
import React from 'react';
import { BRAND_NAME } from '../../constants/Branding';
import { ContactList } from '../../constants/FooterView';
import WhatsupImg from '../../assets/images/footer/whatsapp.png';
import './Copyright.scss';

const Copyright: React.FC = () => {
  return (
    <IonRow class="copyright-ctn">
      <div className="b-text">PEAK GAMING SRL</div>
      <div>San Jose , Costa Rica </div>
      <div className="contact-section">
        {ContactList[BRAND_NAME] ? (
          <>
            <IonImg className="image" src={WhatsupImg} />
            {ContactList[BRAND_NAME]}
          </>
        ) : (
          ''
        )}
      </div>
      <div>
        Copyrights {new Date().getFullYear()}, {BRAND_NAME} | All rights
        reserved
      </div>
    </IonRow>
  );
};

export default Copyright;
